import React from "react";
import { Jumbotron } from "./migration";

const Stack = ({ heading, items }) => {
  return (
    <Jumbotron id="stack" className="m-0">
      <h2 className="section-heading mb-4">{heading}</h2>
      <div className="stack-grid">
        {items.map((item, index) => (
          <div
            className="stack-item"
            key={`stack-${index}`}
            title={item.label}
            aria-label={item.label}
            style={{ "--stack-color": item.color }}
          >
            <i className={item.icon} />
          </div>
        ))}
      </div>
    </Jumbotron>
  );
};

export default Stack;
